import React from 'react';
import UserStore from 'stores/UserStore';
import UserActions from 'actions/UserActions';
import connectToStores from 'alt-utils/lib/connectToStores';
import {UserContextType} from 'components/triggers/UserContextType';

class UserHasManagerConditionComponent extends React.Component {
  static getStores() {
    return [UserStore];
  }

  static getPropsFromStores(nextProps) {
    const {context, contextType} = nextProps;
    const user = UserStore.getState().users.get(context.manager_id);
    if (!user) {
      UserActions.fetchUsers.defer([[context.manager_id]]);
    }
    return {user, contextType};
  }

  render() {
    const {user, contextType} = this.props;
    if (!user) {
      return null;
    }
    return (
      <div>
        {contextType === UserContextType.USER && (
          <span>
            a direct report of{' '}
            <span className="condition-action" onClick={this.props.onClick}>
              {user.getDisplayName()}
            </span>{' '}
            reviews a call
          </span>
        )}
        {contextType === UserContextType.CALLER && (
          <span>
            is placed or received by a direct report of{' '}
            <span className="condition-action" onClick={this.props.onClick}>
              {user.getDisplayName()}
            </span>
          </span>
        )}
        {contextType === UserContextType.CALL && (
          <span>
            the call is placed or received by a direct report of{' '}
            <span className="condition-action" onClick={this.props.onClick}>
              {user.getDisplayName()}
            </span>
          </span>
        )}
      </div>
    );
  }
}

export default connectToStores(UserHasManagerConditionComponent);
